// extracted by mini-css-extract-plugin
module.exports = {"clockDetailsContainer":"ClockOutModal_clockDetailsContainer__3-gW4"};